import { Box, SxProps, Theme, useTheme } from '@mui/material'

import useStyles from './index.styles'

interface StickyHeaderProps {
  children: React.ReactNode
  sx?: SxProps<Theme>
  backgroundColor?: string
  zIndex?: number
  marginBottom?: number
  /**
   * Adds an 8px pseudo-element above the sticky block to mask parent top padding seams
   * where scrolling content can otherwise bleed through.
   */
  includeTopCover?: boolean
  top?: number | string
  /**
   * Expands the sticky block beyond parent horizontal padding (negative side margins + inner px)
   * so the sticky background spans the full content column width.
   */
  fullBleed?: boolean
  paddingX?: number
}

const StickyHeader = ({ children, sx, backgroundColor, zIndex, marginBottom, includeTopCover = false, top, fullBleed = true, paddingX }: StickyHeaderProps) => {
  const theme = useTheme()
  const classes = useStyles

  const stickySx = classes.root(theme, {
    backgroundColor,
    zIndex,
    marginBottom,
    includeTopCover,
    top,
    fullBleed,
    paddingX,
  })

  const mergedSx: SxProps<Theme> = Array.isArray(sx) ? [stickySx, ...sx] : sx ? [stickySx, sx] : stickySx

  return <Box sx={mergedSx}>{children}</Box>
}

export default StickyHeader
